import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import DataPrivacy from '../components/DataPrivacy';

const ViePriveePage = () => {
  useEffect(() => {
    document.title = 'Vie Privée — MonAlerte';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <DataPrivacy />
      </main>
      <Footer />
    </>
  );
};

export default ViePriveePage;
